import { Button as ButtonBase, ButtonProps } from 'antd';

export const Button: React.FC<ButtonProps> = ({ ...props }) => {
  return <ButtonBase {...props} />;
};
